function checkValidationEmail(email) {
    var regex =
        /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|.('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
}

function checkValidationPassword(password) {
    // number, uppercase, lowercase...8 >= length
    var regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return regex.test(password);
}

function checkValidationUsername(name) {
    // lowercase, number, dot, underscore, no space, 3-30
    var regex = /^[^-\s][a-z0-9._]{3,30}$/;
    return regex.test(name);
}

function checkValidationProfilename(name) {
    // alphabet, number, dot, underscore, space, 0-60
    var regex = /^[a-zA-Z0-9._ ]{0,60}$/;
    return regex.test(name);
}

function checkValidationVerificationCode(code) {
    // number, 6 digits
    var regex = /^[0-9]{6}$/;
    return regex.test(code);
}

export {
    checkValidationEmail,
    checkValidationPassword,
    checkValidationUsername,
    checkValidationProfilename,
    checkValidationVerificationCode,
};
